module.exports = __webpack_public_path__ + "img/haircare.20aca324.svg";